(function () {
    'use strict';

    angular
        .module('app')
        .controller('LoginController', LoginController);

    LoginController.$inject = ['auth', 'global', '$state',];

    function LoginController(auth, global, $state) {
        var vm = this;


        vm.login = {};
        vm.isLoggingIn = false;
        vm.global = global;
        vm.submitLogin = submitLogin;

        activate();

        function activate() {
            if (auth.isLoggedIn()) {
                $state.go('dashboard');
            }
        }

        function submitLogin() {
            if (!vm.isLoggingIn) {
                vm.isLoggingIn = true;
                vm.loginError = false;

                auth.login(vm.login.username, vm.login.password).then(function () {
                    vm.isLoggingIn = false;

                    $state.go('dashboard');

                    //TODO: Check if we have an other page to redirect to after login.
                }, function (error) {
                    vm.isLoggingIn = false;
                    vm.loginError = error;
                });
            }
        }
    }
})();